import { browserConstants } from '../constants/actionTypes'

export const setBrowser = (status) => ({
  type: browserConstants.SET_BROWSER,
  payload: status,
})

export const setNotification = (status) => ({
  type: browserConstants.DISPLAY_NOTIFICATION,
  payload: status,
})

export const detectBrowser = () => {
  return (dispatch) => {
    // change below to update the browser names and versions
    const browserVersions = [
      { name: 'chrome', version: 55 },
      { name: 'firefox', version: 50 },
      { name: 'edge-chromium', version: 79 },
      { name: 'edge', version: 79 },
      { name: 'safari', version: 11 },
      { name: 'ios', version: 11 },
      { name: 'ie', version: 99999 },
    ]
    const { detect } = require('detect-browser')
    const browser = detect()
    if (browser) {
      const { name, version, os } = browser
      let majorVersion = parseInt(version.split('.')[0])
      // console.log('Major version: ', majorVersion)
      // console.log(name)
      // console.log(os)
      let outDated = false
      for (let i = 0; i < browserVersions.length; i++) {
        if (browserVersions[i].name === name) {
          if (majorVersion <= browserVersions[i].version) {
            outDated = true
            break
          }
        }
      }
      dispatch(setBrowser(outDated))
    }
  }
}
